<template>
  <div class="page1 f1 df fdc">
    <span v-on:click="addNewTask()" class="add shift-up-30 curp">
      +
    </span>
    <div v-if="hasCompanyTask">
      <CompanyTask
        v-for="(item, key) in companyTasks"
        v-bind:key="key"
        v-bind:taskItem="item"
        v-bind:taskIndex="key"
      />
    </div>
    <div v-else class="notask-templates df fdc">
      <p class="big-text">You currently have no Tasks</p>
      <p class="small-text">
        Tasks represent the people working on your project.<br />
        Roles created here are available to all projects and can be included in
        new projects by default.
      </p>
      <button
        v-on:click="addNewTask()"
        class="button-form button-form-active button-create"
      >
        Create One Now
      </button>
    </div>
  </div>
</template>

<script>
import CompanyTask from "@/components/company/CompanyTask";
export default {
  name: "DashboardTasks",
  data() {
    return {
      // mode: 'login' // login/register
    };
  },
  props: [],
  components: {
    CompanyTask
  },
  methods: {
    addNewTask() {
      var data = {
        companyid: this.$store.getters.myCompany
      };
      console.log("addNewDefaultTask");
      this.$store.dispatch("addNewDefaultTask", data).then(() => {
        console.log("after addNewDefaultTask");
      });
    }
  },
  computed: {
    hasCompanyTask() {
      return this.companyTasks && this.companyTasks.length;
    },
    watch1() {
      return this.$store.getters.companyTasks;
    },
    companyTasks() {
      return [...this.$store.getters.companyTasks].reverse();
    }
  },
  watch: {
    watch1(newVal, oldVal) {
      console.log("<<<<<<<<<<<<<<<<<<<< watch1 changed", newVal, oldVal);
      // console.log('...', newVal, oldVal)
      // this.cancelEdits()
    }
  },
  created() {
    // console.log('** Login Component Loaded')
  }
};
</script>

<style scoped lang="scss">
.notask-templates {
  align-items: center;
  p {
    color: #999999;
    font-family: "GG";
    text-align: center;
  }
  .big-text {
    font-size: 32px;
  }
  .small-text {
    font-size: 12px;
    margin-top: 16px;
  }
  button {
    max-width: 240px;
    margin-top: 44px;
  }
}
.page1 {
  position: relative;
  width: 100%;
}
.add {
  position: absolute;
  top: -80px;
  right: 10px;
  z-index: 6;
  height: 60px;
  width: 60px;
  background-color: #5558ff;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.26);
  border-radius: 50%;
  position: absolute;
  transform: translateY(100%);
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  justify-content: center;
  -ms-align-items: center;
  align-items: center;
  color: white;
  font-size: 28px;
  font-weight: 500;
}
</style>
